import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnamneseConfiguracaoEditarRoutingModule } from './anamnese-configuracao-editar-routing.module';
import { AnamneseConfiguracaoEditarComponent } from './anamnese-configuracao-editar.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    AnamneseConfiguracaoEditarComponent
  ],
  imports: [
    CommonModule,
    AnamneseConfiguracaoEditarRoutingModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    MessagesModule,
    DividerModule,
    InputSwitchModule,
    TooltipModule,
    ProgressSpinnerModule
  ]
})
export class AnamneseConfiguracaoEditarModule { }
